module.exports = __webpack_public_path__ + "img/left_orange_arrow.43389b14.svg";